import type { OverlayTriggerState } from '@heroui/react';
import { ConfirmDialog } from '../../../components/ui/confirm-dialog';

interface ConfirmBulkCancelModalProps {
  state: OverlayTriggerState;
  onConfirm: () => Promise<void>;
}

export function ConfirmBulkCancelModal({ state, onConfirm }: ConfirmBulkCancelModalProps) {
  return (
    <ConfirmDialog
      state={state}
      title="Cancelar solicitação em massa"
      cancelLabel="Manter"
      confirmLabel="Sim, cancelar"
      confirmVariant="danger"
      onConfirm={onConfirm}
      message={
        <p className="text-muted">
          Tem certeza que deseja cancelar esta solicitação em massa? Ela deixará de buscar vagas
          disponíveis.
        </p>
      }
    />
  );
}
